import ObjectID from 'bson-objectid';
import { Field } from 'mobx-react-form';

import { FormField } from 'components/shared/form';
import { ExpenseHistory } from 'types/underwriting/income-approach/expenses';

export const operatingExpenseFormFields: FormField[] = [
  {
    name: 'incomeApproach',
    fields: [
      {
        name: 'expenses',
        fields: [
          {
            name: 'expenseHistoryEntryMode',
            type: 'text',
            value: 'detailed',
          },
          {
            name: 'expenseHistoryInputMethod',
            type: 'text',
            value: 'amount',
          },
          {
            name: 'expenseHistory',
            type: 'array',
            value: [],
          },
          {
            name: 'expenseCategories',
            type: 'array',
            value: [],
          },
          {
            name: 'expenseCategories[]',
            fields: [
              {
                name: 'key',
                type: 'text',
                value: '',
              },
              {
                name: 'category',
                type: 'text',
                value: '',
              },
              {
                name: 'isCustom',
                type: 'boolean',
                value: false,
              },
            ],
          },
        ],
      },
    ],
  },
  {
    name: 'expenseDialog',
    fields: [
      {
        name: 'expenseName',
        type: 'text',
        bindings: 'TextField',
        value: '',
      },
    ],
  },
];

export const expenseFormHelpers = {
  addExpenseCategory: (form: any, categoryName: string, categoryKey: string) => {
    const expenseCategoriesField: Field = form.$('incomeApproach.expenses.expenseCategories');
    const expenseHistoryField: Field = form.$('incomeApproach.expenses.expenseHistory');

    expenseCategoriesField.add([
      {
        category: categoryName,
        key: categoryKey,
        isCustom: true,
      },
    ]);

    (expenseHistoryField.value || []).forEach((field: any, index: number) => {
      const updatedData = {
        ...field,
        expenses: [...(field.expenses || []), { category: categoryName, value: 0 }],
      };

      form.$(`incomeApproach.expenses.expenseHistory.${index}`).update(updatedData);
    });
  },

  removeExpenseCategory: (form: any, categoryName: string) => {
    const expenseCategoriesField = form.$('incomeApproach.expenses.expenseCategories');

    const currentCategories = expenseCategoriesField.value || [];
    const index = currentCategories.findIndex((cat: any) => cat.category === categoryName);

    const lastIndex = currentCategories.length - 1;

    const newExpenseCategories = currentCategories.filter((_: Record<string, any>, i: number) => i !== index);

    expenseCategoriesField.set(newExpenseCategories);

    try {
      expenseCategoriesField.del(lastIndex);
    } catch (error) {
      console.log('error deleting', error);
    }

    // // eslint-disable-next-line no-restricted-syntax
    // let removedCategoryKey: string | null = null;
    // expenseCategoriesField.each((field: Field) => {
    //   if (field.value.category === categoryName) {
    //     removedCategoryKey = field.key;
    //   }
    // });
    // if (removedCategoryKey) {
    //   expenseCategoriesField.del(removedCategoryKey);
    // }

    const expenseHistoryField = form.$('incomeApproach.expenses.expenseHistory');
    const currentHistory = expenseHistoryField.value || [];

    const updatedHistory = currentHistory.map((historyItem: any) => {
      const expenses = historyItem.expenses?.filter((exp: any) => exp.category !== categoryName);
      historyItem.expenses = [...expenses];
      return historyItem;
    });
    expenseHistoryField.set(updatedHistory);
  },

  addExpenseYear: (form: any, year: number, period: string, month: string) => {
    const expenseHistoryField = form.$('incomeApproach.expenses.expenseHistory');
    const expenseCategoriesField = form.$('incomeApproach.expenses.expenseCategories');

    const expenseCategories = expenseCategoriesField.value || [];

    const newExpenseHistory = {
      year,
      period,
      month,
      expenses: expenseCategories.map((category: any) => ({
        category: category.category,
        value: 0,
      })),
      id: new ObjectID().toHexString(),

      totalExpenseAmount: 0,
      operatingExpenseRatio: 0,
    };

    expenseHistoryField.add([newExpenseHistory]);
  },

  removeExpenseYear: (form: any, expenseHistoryId: string) => {
    if (!expenseHistoryId) {
      return;
    }

    const expenseHistoryField = form.$('incomeApproach.expenses.expenseHistory');
    const currentHistory: ExpenseHistory[] = expenseHistoryField.value || [];

    const lastIndex = currentHistory.length - 1;

    const updatedExpenseHistory = currentHistory.filter(
      (expenseHistoryItem: ExpenseHistory) => expenseHistoryItem.id !== expenseHistoryId
    );

    if (currentHistory.length !== updatedExpenseHistory.length) {
      expenseHistoryField.set(updatedExpenseHistory);
      expenseHistoryField.del(lastIndex);
    }
  },

  updateExpenseValue: (form: any, categoryName: string, yearKey: string, value: number) => {
    const expenseHistoryField = form.$('incomeApproach.expenses.expenseHistory');
    const currentHistory = expenseHistoryField.value || [];

    const updatedHistory = currentHistory.map((historyItem: any, index: number) => {
      let expenses = historyItem.expenses;
      if (`${historyItem.period}-${historyItem.year}` === yearKey) {
        const existingExpense = historyItem.expenses?.find((exp: any) => exp.category === categoryName);
        if (existingExpense) {
          expenses = historyItem.expenses.map((exp: any) => (exp.category === categoryName ? { ...exp, value } : exp));
        } else {
          expenses = [...(historyItem.expenses || []), { category: categoryName, value }];
        }
      }
      historyItem.expenses = [...expenses];
      return historyItem;
    });

    expenseHistoryField.set(updatedHistory);
  },
};
